module.exports = __webpack_public_path__ + "img/logo.a8bdc5f8.png";